import React, { useEffect, useState, useCallback } from 'react';
import { Container, Image, Button } from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import { IMAGE_PATHS } from 'constants/imagePaths';
import { NavLink, useLocation } from 'react-router-dom';
import PublicHeader from './PublicHeader';
import PrivateHeader from './PrivateHeader';
import useAuthStore from 'store/auth';
import Sidebar from 'components/Sidebar';
import './styles.scss';
import { logLogoClick } from 'services';

const Header: React.FC = () => {
	const { token }: Record<string, any> = useAuthStore((state) => state.userInfo ?? {});
	const location = useLocation();
	const isAlternate = location.pathname === '/interactive-demo';

	const [showModal, setShowModal] = useState(false);

	// Memoize event handlers
	const handleShow = useCallback(() => {
		setShowModal(true);
	}, []);

	const handleModalClose = useCallback(() => {
		setShowModal(!showModal);
	}, [showModal]);

	const handleLogoClick = useCallback(() => {
		logLogoClick(location.pathname);
	}, [location.pathname]);

	useEffect(() => {
		const launcherElement = document.getElementById('launcher');
		if (launcherElement) {
			if (showModal) {
				launcherElement.classList.add('d-none');
			} else {
				launcherElement.classList.remove('d-none');
			}
		}
	}, [showModal]);

	return (
		<Navbar collapseOnSelect sticky="top" className={`bg-white ${!token ? 'nav-mobile' : ''}`}>
			<Container fluid className="position-relative">
				{token && (
					<Button
						variant="primary"
						onClick={handleShow}
						className="sidebar-btn d-xl-none bg-transparent border-0 p-0"
						aria-label="Toggle sidebar menu"
						aria-expanded={showModal}
					>
						<i className="ri-bar-chart-horizontal-line" aria-hidden="true"></i>
					</Button>
				)}
				{showModal && <Sidebar showModal={showModal} onClose={handleModalClose} />}

				<NavLink
					to="/"
					className="navbar-brand text-center p-0 text-decoration-none lh-1"
					onClick={handleLogoClick}
					aria-label="Navigate to home page"
				>
					<Image src={IMAGE_PATHS.JobstasLogoHeader} alt="Jobstas Logo" loading="lazy" />
				</NavLink>
				<Navbar.Toggle
					aria-controls="responsive-navbar-nav"
					className="border-0"
					aria-label="Toggle navigation menu"
				/>
				{token && !isAlternate ? <PrivateHeader /> : <PublicHeader />}
			</Container>
		</Navbar>
	);
};

// Add display name for debugging
Header.displayName = 'Header';

export default React.memo(Header);
